<template>
  <section>
    <b-modal
      :visible="visible"
      hide-footer
      button-size="sm"
      size="lg"
      modal-cancel="false"
      no-close-on-backdrop
      @close="close"
      id="course-offered-add"
    >
      <template v-slot:modal-title>Añadir pago adelantado</template>
      <section class="container-fluid">
        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="add">
            <section class="row">
              <!-- Gestión -->
              <div class="col-12 col-xl">
                <div class="form-group required">
                  <ValidationProvider
                    name="total_credit"
                    rules="required"
                    v-slot="{ valid, errors }"
                  >
                    <label class="control-label" for="total_credit"
                      >Crédito
                    </label>
                    <currency-input
                      v-model="creditTransaction.total_credit"
                      class="form-control form-control-sm"
                      id="total_credit"
                    />
                    <b-form-invalid-feedback :state="valid">{{
                      errors[0]
                    }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Periodo -->
              <div class="col"></div>
            </section>

            <section class="row">
              <!-- Descripción -->
              <div class="col-12 col-xl-12">
                <div class="form-group required">
                  <ValidationProvider
                    name="observation"
                    rules="required"
                    v-slot="{ valid, errors }"
                  >
                    <label class="control-label" for="observation"
                      >Descripción
                    </label>
                    <b-form-textarea
                      id="observation"
                      v-model="creditTransaction.observation"
                      class="form-control form-control-sm"
                      rows="2"
                      max-rows="3"
                    ></b-form-textarea>
                    <b-form-invalid-feedback :state="valid">{{
                      errors[0]
                    }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </div>
              </div>
            </section>

            <section class="row">
              <!-- Cliente -->
              <div class="col-12 col-xl-6">
                <div class="form-group required">
                  <ValidationProvider
                    name="customer_id"
                    rules="required"
                    v-slot="{ valid, errors }"
                  >
                    <label class="control-label" for="customer_id"
                      >Cliente</label
                    >
                    <b-input-group>
                      <v-select
                        label="name"
                        :options="customersOptions"
                        @search="onSearchCustomers"
                        v-model="creditTransaction.customer_id"
                        :reduce="(customer) => customer.id"
                        id="customer_id"
                        style="width: calc(100% - 62px)"
                        placeholder="Buscar Cliente"
                      >
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            No hay resultados para <em>{{ search }}</em
                            >.
                          </template>
                          <em v-else>Buscar Cliente</em>
                        </template>
                        <template v-slot:option="option">
                          <span :class="option.icon"></span>
                          {{ `${option.name}` }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ `${option.name}` }}
                          </div>
                        </template>
                      </v-select>
                      <b-input-group-append>
                        <button
                          @click="customerAddMod"
                          class="btn btn-success btn-sm"
                          type="button"
                        >
                          <CIcon size="sm" name="cib-Addthis" />
                        </button>
                        <button
                          @click="customerListMod"
                          class="btn btn-info btn-sm"
                          type="button"
                        >
                          <CIcon size="sm" name="cil-list" />
                        </button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback :state="valid">{{
                      errors[0]
                    }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Formas de pago -->
              <div class="col-12 col-xl">
                <PaymentMethodRadioInput
                  v-model="creditTransaction.payment_method_id"
                  :name="'payment_method_id'"
                  :rules="'required'"
                  :value="creditTransaction.payment_method_id"
                  :disabled="creditTransaction.payment_method_id == 6"
                />
              </div>
            </section>

            <b-button type="button" size="sm" variant="danger" @click="close">
              <CIcon size="sm" name="cil-x-circle" /> Cancelar
            </b-button>

            <button
              type="submit"
              class="btn btn-success btn-sm float-right"
              variant="success"
              :disabled="invalid || addLoader"
            >
              <span v-if="!addLoader">
                <CIcon size="sm" name="cil-save" /> Guardar
              </span>
              <span v-if="addLoader">
                Cargando
                <CSpinner color="success" size="sm" />
              </span>
            </button>
          </form>
        </ValidationObserver>
      </section>
    </b-modal>
    <!-- nuevo customer -->
    <section v-if="modShowCustomerAdd">
      <CustomerAddModal
        :modShowCustomerAdd="modShowCustomerAdd"
        @customerAddModal="afterAddCustomer"
      >
      </CustomerAddModal>
    </section>
    <!-- listar customer -->
    <section v-if="modShowCustomerList">
      <CustomerListModal
        :modShowCustomerList="modShowCustomerList"
        @customerListModal="afterListCustomer"
      >
      </CustomerListModal>
    </section>
  </section>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BModal,
  BButton,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import CreditTransactions from "@/plugins/services/credit-transactions";
import Customers from "@/plugins/services/customers";
// components
import CustomerAddModal from "@/entities/customers/CustomerAddModal";
import CustomerListModal from "@/entities/customers/CustomerListModal";
import PaymentMethodRadioInput from "@/entities/payment-methods/PaymentMethodRadioInput";

export default {
  name: "CreditTransactionAddModal",
  components: {
    BFormInvalidFeedback,
    BFormSelect,
    BFormSelectOption,
    BModal,
    BButton,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    PaymentMethodRadioInput,
    CustomerAddModal,
    CustomerListModal,
  },
  props: {
    modShowAddCreditTransaction: { type: Boolean, required: true },
    student_id: { type: Number, required: true },
    customer_id: { type: Number },
  },
  data() {
    return {
      creditTransaction: {
        payment_method_id: 2,
        transaction_type: "CREDIT",
      },
      addLoader: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
      customersOptions: [],
      modShowCustomerAdd: false,
      modShowCustomerList: false,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowAddCreditTransaction;
    },
  },
  mounted() {
    this.creditTransaction.customer_id = this.customer_id;
    this.creditTransaction.student_id = this.student_id;
    if (this.customer_id) this.getCustomerById(this.customer_id);
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });
  },
  methods: {
    add() {
      this.addLoader = true;
      this.creditTransaction.created_by = this.userAuth.username;
      this.creditTransaction.user_id = this.userAuth.id;
      CreditTransactions.add(this.creditTransaction)
        .then((res) => {
          this.addLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.addLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", res.data.message);
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al crear(500).");
            this.closeModal(null, 500);
          }
        });
    },
    // search Customers
    onSearchCustomers(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getCustomers(loading, search);
      }
    },
    getCustomers(loading = null, search = null) {
      Customers.selectAll(search)
        .then((res) => {
          this.customersOptions = res.data;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
        });
    },
    getCustomerById(customer_id) {
      Customers.selectAllById(customer_id)
        .then((res) => {
          this.customersOptions = res.data;
          if (this.customersOptions.length == 0) {
            this.creditTransaction.customer_id = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    customerAddMod() {
      this.modShowCustomerAdd = true;
    },
    afterAddCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.creditTransaction.customer_id = response.data.id;
        this.getCustomerById(response.data.id);
      }
      this.modShowCustomerAdd = response.modalShow;
    },
    customerListMod() {
      this.modShowCustomerList = true;
    },
    afterListCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.creditTransaction.customer_id = response.data.id;
        this.getCustomerById(response.data.id);
      }
      this.modShowCustomerList = response.modalShow;
    },
    closeModal(data = null, status = 200) {
      this.sale = {};
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("creditTransactionAdd", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
